import axios from 'axios';
import {REP_API_URL} from '../utils/constants.js';

class NewsService {
    async getMotorTraining(data){
        const url = `${REP_API_URL}get-motor-training/`;
        const headers = {
            'Content-Type': 'application/json'
        };
        let formData = data;
        return axios({
            url:url,
            method: 'POST',
            data: formData,
            headers: headers
        }).then(function(response){
            return response;
        }).catch(function(error){
            return error.response;
        });
    }

    async getTrainingVideos(data){
        const url = `${REP_API_URL}get-training-videos/`;
        const headers = {
            'Content-Type': 'application/json'
        };
        let formData = data;
        return axios({
            url:url,
            method: 'POST',
            data: formData,
            headers: headers
        }).then(function(response){
            return response;
        }).catch(function(error){
            return error.response;
        });
    }

    async getInformationStations(data){
        const url = `${REP_API_URL}get-information-stations/`;
        const headers = {
            'Content-Type': 'application/json'
        };
        let formData = data;
        return axios({
            url:url,
            method: 'POST',
            data: formData,
            headers: headers
        }).then(function(response){
            return response;
        }).catch(function(error){
            return error.response;
        });
    }

    async shareInformation(data){
        const url = `${REP_API_URL}share-information-station-file/`;
        const headers = {
            'Content-Type': 'application/json'
        };
        let formData = data;
        return axios({
            url:url,
            method: 'POST',
            data: formData,
            headers: headers
        }).then(function(response){
            return response;
        }).catch(function(error){
            return error.response;
        });
    }

    async downloadFile(file_url) {
        const url = `${REP_API_URL}download-file/?url=${encodeURIComponent(file_url)}`;

        return axios({
            url: url,
            method: 'GET',
            responseType: 'blob', // ✅ VERY IMPORTANT
        })
        .then(response => response)
        .catch(error => { throw error });
    }
}

export default NewsService;